import React, { useEffect } from 'react';
import { UrgencyBar } from '../components/UrgencyBar';
import { HeroSection } from '../components/HeroSection';
import { SalesLetterSection } from '../components/SalesLetterSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { ObjectionsSection } from '../components/ObjectionsSection';
import { BonusesSection } from '../components/BonusesSection';
import { TrustBadgeSection } from '../components/TrustBadgeSection';
import { CheckoutSection } from '../components/CheckoutSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { ClosingCTASection } from '../components/ClosingCTASection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { PurchasePopup } from '../components/PurchasePopup';
export function LandingPage() {
  useEffect(() => {
    document.title = 'HUERTA 360';
    if (typeof window !== 'undefined' && (window as any).fbq) {
      ;
      (window as any).fbq('track', 'PageView');
    }
  }, []);
  return <div className="min-h-screen bg-black text-gray-200 font-sans selection:bg-green-500 selection:text-black" data-id="element-221">
      <UrgencyBar data-id="element-222" />

      <main data-id="element-223">
        <HeroSection data-id="element-224" />
        <TrustBadgeSection data-id="element-225" />
        <SalesLetterSection data-id="element-226" />
        <BenefitsSection data-id="element-227" />
        <BonusesSection data-id="element-228" />
        <CheckoutSection data-id="element-229" />
        <GuaranteeSection data-id="element-230" />
        <ObjectionsSection data-id="element-231" />
        <ClosingCTASection data-id="element-232" />
        <TestimonialsSection data-id="element-233" />
      </main>

      <footer className="py-12 bg-zinc-950 border-t border-zinc-900 text-center text-zinc-600 text-sm" data-id="element-234">
        <div className="max-w-6xl mx-auto px-4" data-id="element-235">
          <p className="mb-4" data-id="element-236">
            © 2025 Huerta Productiva 360°. Todos los derechos reservados.
          </p>
          <div className="flex justify-center gap-6" data-id="element-237">
            <a href="#" className="hover:text-zinc-400 transition-colors" data-id="element-238">
              Términos y Condiciones
            </a>
            <a href="#" className="hover:text-zinc-400 transition-colors" data-id="element-239">
              Política de Privacidad
            </a>
            <a href="#" className="hover:text-zinc-400 transition-colors" data-id="element-240">
              Soporte
            </a>
          </div>
        </div>
      </footer>

      <PurchasePopup data-id="element-241" />
    </div>;
}